import { Component, OnInit, Inject } from '@angular/core';
import { SupportService } from '../services/support.service';
import { NgForm } from '@angular/forms';
import { delay, finalize } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupportFaq } from '../models/supportFaqs.interface';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SupportFaqHyperlink } from '../models/supportFaqs.hyperlink.interface';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-faq-edit',
  templateUrl: './faq-edit.component.html',
  styleUrls: ['./faq-edit.component.scss']
})

export class FaqEditComponent extends AbstractBiditComponent implements OnInit {

  constructor(deviceDetectorService: DeviceDetectorService,
    private supportService: SupportService, public dialogRef: MatDialogRef<FaqEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    super(deviceDetectorService);
  }

  pageTitle: string = "Faq";

  faq: SupportFaq;

  ngOnInit() {
    if (this.data.id == null) {
      this.faq = {
        supportFaq_Locale: 'en'
      } as SupportFaq;
      this.faq.hyperlinks = [];
    }    
    else {
      this.supportService.getFaq(this.data.id)
        .subscribe({
          next: (data) => {
            this.faq = data;
          },
          error: (error: string) => this.onError(error)
        });
    }
  }

  addHyperlink(): void {
    let hyperlink = {} as SupportFaqHyperlink;
    hyperlink.supportFaqHyperlink_Description = 'How To Video';

    this.faq.hyperlinks.push(hyperlink);
  }

  removeHyperlink(hyperlink: SupportFaqHyperlink): void {
    let index = this.faq.hyperlinks.indexOf(hyperlink);
    this.faq.hyperlinks.splice(index, 1);
  }

  saveFaq(form: NgForm) {
    this.errors = '';

    if (form.valid) {
      this.isRequesting = true;

      this.supportService.saveFaq(this.faq)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe(
          { next:(result) => {
            if (result) {
              this.dialogRef.close(result);
            }
          },
          error: (error: string) => this.errors = error});
    }
  }

  drop(event: CdkDragDrop<SupportFaqHyperlink[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.faq.hyperlinks = event.container.data;
    };
  }

  onNoClick(): void {
    var proceed = confirm($localize`Are you sure?`);

    this.dialogRef.close();
  }

}
